{{ getDate(start) }}
<ng-container *ngIf="end">- {{ getDate(end, start) }}</ng-container>
{{ getTimeZone() }}
